module.exports = {
      id: "pinterest-usage",
      viewBox: "0 0 44 44",
      url: __webpack_public_path__ + "svg-sprite-afa9d3605aa6d2fee8793cc86cfa3445.svg#pinterest",
      toString: function () {
        return this.url;
      }
    }